import { useState } from 'react';
import { ExerciseWeightMode } from '@guryou/core';

const useWeightMode = () => {
  const [values, setValues] = useState(null);

  if (!values) {
    setValues([
      { value: ExerciseWeightMode.kg, label: 'KG' },
      { value: ExerciseWeightMode.kgPerSide, label: 'KG per side' },
      { value: ExerciseWeightMode.rpe, label: 'RPE' },
      { value: ExerciseWeightMode.oneRm, label: '1-RM' },
      { value: ExerciseWeightMode.buffer, label: 'Buffer' },
    ]);
  }

  return values;
};

export default useWeightMode;
